<template>
    <div class="top-container">
        <div class="left-column">
            <switch-shared v-show="true" :shared="state.shared" @shared-switched="switchMode" />
        </div>
    </div>
    <div class="shared" v-if="state.shared == SharedTypes.SHARED">
        <div for="sharedHeading" class="text-center bg-red-500 text-yellow-400 font-bold">WARNING: Shared Formulas will be saved publicly</div>
        <Divider />
    </div>
    <Accordion :activeIndex="state.activeTab" @tab-open="tabOpen">
        <AccordionTab header="General Information">
            <div class="grid">
                <div class="form-field col">
                    <label for="name">Name</label>
                    <InputText maxlength = "255" :class="{ 'p-invalid': state.nextClicked && !state.formulaName }" v-model="state.formulaName" placeholder="Enter unique formula name" />
                    <small class="p-invalid" v-if="state.nextClicked && !state.formulaName">Formula Name is required.</small>
                </div>
                <div class="form-field col">
                    <label for="code">Code</label>
                    <InputText maxlength = "255" :modelValue="state.formula.code" placeholder="Equivalent code of formula entered" :disabled="true" />
                </div>
                <div class="form-field col">
                    <label for="type">Type</label>
                    <Dropdown :class="{ 'p-invalid': state.nextClicked && !state.formula.type }" v-model="state.formula.type" :options="state.types" optionLabel="name" optionValue="id" placeholder="Select Formula Type" showClear />
                    <small class="p-invalid" v-if="state.nextClicked && !state.formula.type">Formula Type is required.</small>
                </div>
            </div>
            <div class="form-field">
                <label for="description">Description</label>
                <Textarea rows="5" v-model="state.formula.description" />
            </div>
            <Button label="Next" @click="next" :disabled="!state.formula.code && !state.formula.type" />
        </AccordionTab>
        <AccordionTab header="Formula Builder" :disabled="!state.formula.code || !state.formula.type">
            <div class="container shadow-2 surface-card">
                <formula-builder :shared="state.shared" :disableSubmit="!state.formula.code" @submit-formula="submitFormula" />
            </div>
        </AccordionTab>
    </Accordion>
    <div class="shared" v-if="state.shared == SharedTypes.SHARED">
        <div for="sharedHeading" class="text-center bg-red-500 text-yellow-400 font-bold">WARNING: Shared Formulas will be saved publicly</div>
        <Divider />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { reactive, watch } from 'vue';
import SwitchShared from '@/components/SwitchShared.vue';
import FormulaBuilder from '@/components/formula/FormulaBuilder.vue';
import useFormulaComposable from '@/composables/FormulaComposable';
import useFormulaBuilderComposable from '@/composables/FormulaBuilderComposable';
// import useBlockComposable from '@/composables/BlockComposable';
import { getFormulaTypes } from '@/helpers/enum-helpers';
import { generateUnderscoreCode } from '@/helpers/text-formatter';
import { SharedTypes } from '@/enums';
import { showToast } from '@/helpers/toast-handler';

const router = useRouter();
const { formula, addFormula } = useFormulaComposable();
const { getFormattedFormulaArray } = useFormulaBuilderComposable();
// const { getAllBlocks } = useBlockComposable();
const createInitialState = () => {
    return reactive({
        shared: SharedTypes.COMPANY,
        activeTab: 0,
        types: getFormulaTypes(),
        formula: {
            code: null,
            description: null,
            type: null,
            formula: [],
        },
        formulaName: null,
        nextClicked: false,
    });
};

const state = createInitialState();

// onMounted(async () => {
//     await getAllBlocks(state.shared, { default: true });
// });

watch(
    () => state.formulaName,
    () => {
        if (state.formulaName) {
            state.formula.code = generateUnderscoreCode(state.formulaName);
        }
    }
);

// updates activeTab index everytime an accordion tab is opened
const tabOpen = (event) => {
    state.activeTab = event.index;
};

const next = () => {
    state.nextClicked = true;
    if (state.formula.code && state.formula.type) {
        state.activeTab = 1;
        state.nextClicked = false;
    } else {
        showToast({}, 'Required fields cannot be empty');
    }
};

const switchMode = async (mode) => {
    state.shared = mode;
};

const submitFormula = async () => {
    state.formula.formula = getFormattedFormulaArray();
    await addFormula(state.shared, state.formula);
    if (formula) {
        setTimeout(() => router.push({ name: 'Formula' }), 1000);
    }
};
</script>

<style scoped>
.right-column {
    padding: 1rem;
}
.container > div {
    padding: 1rem;
}

.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}
</style>
